import { Button, Stack, Text } from '@iwoca/orion';
import { maintainStateKey } from '@iwRouter/LocationHelper';
import { FormattedMessage } from 'react-intl';
import { useHistory, useLocation } from 'react-router-dom';

import { FUNDING_REQUIREMENTS_LIST_PATH } from '../../../../requirementStepPaths';

export const IdCheckComplete = () => {
    const history = useHistory();
    const { search } = useLocation();

    return (
        <Stack gap="section">
            <Stack>
                <Text className="text-3xl font-bold">
                    <FormattedMessage
                        id="_.funding_requirements_v2.id_verification.complete_title"
                        defaultMessage="You’ve completed your ID check"
                    />
                </Text>
                <Text className="text-xl">
                    <FormattedMessage
                        id="_.funding_requirements_v2.id_verification.complete_subtitle"
                        defaultMessage="You can now continue with the remaining checks."
                    />
                </Text>
            </Stack>
            <Button
                variant="primary-rounded"
                size="large"
                type="button"
                onClick={() =>
                    history.push(
                        maintainStateKey({
                            pathname: FUNDING_REQUIREMENTS_LIST_PATH,
                            search
                        })
                    )
                }
            >
                <FormattedMessage
                    id="_.funding_requirements_v2.id_verification.back_to_final_checks"
                    defaultMessage="Back to final checks"
                />
            </Button>
        </Stack>
    );
};
